var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.472168,
    width: 36,
    height: 36,
    rx: 8,
    fill: "#E9EBEC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4722 12C14.4722 10.8954 15.3676 10 16.4722 10H24.4722C25.5767 10 26.4722 10.8954 26.4722 12V20C26.4722 21.1046 25.5767 22 24.4722 22H16.4722C15.3676 22 14.4722 21.1046 14.4722 20V12ZM16.4722 11C15.9199 11 15.4722 11.4477 15.4722 12V20C15.4722 20.5523 15.9199 21 16.4722 21H24.4722C25.0245 21 25.4722 20.5523 25.4722 20V12C25.4722 11.4477 25.0245 11 24.4722 11H16.4722ZM12.4722 15C11.9199 15 11.4722 15.4477 11.4722 16V24C11.4722 24.5523 11.9199 25 12.4722 25H20.4722C21.0245 25 21.4722 24.5523 21.4722 24V23H22.4722V24C22.4722 25.1046 21.5767 26 20.4722 26H12.4722C11.3676 26 10.4722 25.1046 10.4722 24V16C10.4722 14.8954 11.3676 14 12.4722 14H13.4722V15H12.4722Z",
    fill: "#272A3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy-icon.b3a177edd5e5bc092be32e861adbd3bb.svg";
export { ForwardRef as ReactComponent };